<script>
import SkyScroll from 'sky-scroll';

export default {
	props: ['name'],
	data() {
		return {
			overlayStyle: {
				visibility: 'hidden',
				position: 'absolute',
				top: '',
			},
		};
	},
	created() {
		this.$store.commit('skyOverlay/register', this.name);
	},
	beforeDestroy() {
		this.$store.commit('skyOverlay/unregister', this.name);
	},
	computed: {
		active() {
			// TODO: Try getting overlay name directly from vuex store
			const overlays = this.$store.getters['skyOverlay/overlays'];
			if (this.name in overlays) {
				return overlays[this.name].active;
			}
			return false;
		},
	},
	methods: {
		toggle(state) {
			this.$store.dispatch('skyOverlay/toggle', {
				name: this.name,
				active: state,
			});
		},
		enter() {
			this.overlayStyle = {
				visibility: 'visible',
				position: '',
				top: '',
			};
		},
		leave() {
			this.overlayStyle = {
				visibility: 'visible',
				position: 'fixed',
				top: `${-window.pageYOffset}px`,
			};
		},
		afterLeave() {
			this.overlayStyle = {
				visibility: 'hidden',
				position: 'absolute',
				top: '',
			};
			SkyScroll.recalculate();
		},
	},
};
</script>

<style src="./sky-overlay.scss"></style>
<template src="./sky-overlay.html"></template>



// WEBPACK FOOTER //
// sky-overlay.vue?31d9b97c